import React from 'react';

export default function TrasladoDetalleModal({ traslado, onClose }) {
  const details = traslado.details || [];
  const totalQty = details.reduce((s, d) => s + (d.quantity || 0), 0);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 640, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div className="section-header">
          <h6>
            <i className="bi bi-arrow-left-right" style={{ color: 'var(--orig-green)' }} />
            Traslado #{traslado.id}
          </h6>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
            title="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="section-body">
          <div className="row g-3" style={{ marginBottom: 18 }}>
            <div className="col-6 col-md-3">
              <div style={{ fontSize: 11, color: 'var(--orig-text-muted)', marginBottom: 2 }}>Fecha</div>
              <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--orig-text)' }}>
                {traslado.date?.slice(0, 10)}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div style={{ fontSize: 11, color: 'var(--orig-text-muted)', marginBottom: 2 }}>Origen</div>
              <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--orig-text)' }}>
                {traslado.branchOrigin?.name}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div style={{ fontSize: 11, color: 'var(--orig-text-muted)', marginBottom: 2 }}>Destino</div>
              <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--orig-text)' }}>
                {traslado.branchDest?.name}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div style={{ fontSize: 11, color: 'var(--orig-text-muted)', marginBottom: 2 }}>Creado</div>
              <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--orig-text)' }}>
                {traslado.createdAt ? new Date(traslado.createdAt).toLocaleString('es-VE') : '—'}
              </div>
            </div>
            {traslado.observations && (
              <div className="col-12">
                <div style={{ fontSize: 11, color: 'var(--orig-text-muted)', marginBottom: 2 }}>Observaciones</div>
                <div style={{ fontSize: 13, color: 'var(--orig-text)' }}>{traslado.observations}</div>
              </div>
            )}
          </div>

          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--orig-text)' }}>
              Productos y equipos del traslado
            </span>
            <span className="badge-orig badge-green">
              {totalQty} unidades en total
            </span>
          </div>

          <table className="orig-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Producto / Equipo</th>
                <th>Tipo</th>
                <th>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              {details.map((d, idx) => {
                const isEquipment = Boolean(d.equipmentId);
                return (
                  <tr key={d.id}>
                    <td style={{ color: 'var(--orig-text-muted)', fontSize: 12, fontFamily: 'monospace' }}>
                      {idx + 1}
                    </td>
                    <td style={{ fontWeight: 500 }}>
                      {isEquipment ? d.equipment?.name : d.product?.name}
                    </td>
                    <td>
                      <span className={`badge-orig ${isEquipment ? 'badge-amber' : 'badge-green'}`}>
                        <i className={`bi ${isEquipment ? 'bi-pc-display' : 'bi-box-seam'}`} style={{ fontSize: 10 }} />
                        {isEquipment ? 'Equipo' : 'Producto'}
                      </span>
                    </td>
                    <td style={{ fontSize: 13, fontWeight: 600, color: 'var(--orig-text)' }}>{d.quantity}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
